import React, { useState } from "react";
import { Star } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function FeaturedControls({ event, onChange }) {
  const { t } = useApp();
  const [from, setFrom] = useState(event.featured_from || "");
  const [until, setUntil] = useState(event.featured_until || "");
  const [busy, setBusy] = useState(false);

  const save = async (featured) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/events/${event.event_id}/featured`, {
        featured, featured_from: from || null, featured_until: until || null,
      });
      onChange(data); toast.success("Done");
    } catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
    setBusy(false);
  };

  return (
    <div className="mt-4 p-3 border border-dashed border-foreground" data-testid={`featured-controls-${event.event_id}`}>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="eyebrow flex items-center gap-1"><Star className="w-3 h-3" /> {t("featured")}
          {event.featured && <span className={`ml-2 px-2 py-0.5 border ${event.is_featured ? "bg-primary text-primary-foreground" : ""}`}>{event.is_featured ? "active" : "scheduled/expired"}</span>}
        </div>
        <span className="text-xs text-muted-foreground">{t("featuredHint")}</span>
      </div>
      <div className="mt-3 grid grid-cols-2 md:grid-cols-4 gap-2 items-end">
        <div><label className="eyebrow">{t("featuredFrom")}</label><input type="date" className="gg-input mt-1" value={from} onChange={e => setFrom(e.target.value)} data-testid={`featured-from-${event.event_id}`} /></div>
        <div><label className="eyebrow">{t("featuredUntil")}</label><input type="date" className="gg-input mt-1" value={until} onChange={e => setUntil(e.target.value)} data-testid={`featured-until-${event.event_id}`} /></div>
        <button disabled={busy} onClick={() => save(true)} className="gg-btn-primary" data-testid={`featured-set-${event.event_id}`}>{t("setFeatured")}</button>
        <button disabled={busy || !event.featured} onClick={() => save(false)} className="gg-btn" data-testid={`featured-unset-${event.event_id}`}>{t("unsetFeatured")}</button>
      </div>
    </div>
  );
}
